























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { translateErrorMessage } from "../../../services/Helpers";
import FullScreenModal from "../../shared/modal/FullScreenModal.vue";
import ProformaModal from "../ShipmentsManagement/ProformaModal.vue";
import {
  ShipmentManagementDef,
  ProformaManagementDef
} from "../../../model/component.model";
import {
  ShipmentDTO,
  AddressShipmentDTO,
  ProformaDTO,
  OnlineMbeShipmentTemplateDto
} from "../../../model/data.model";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import { ShipmentService } from "../../../services/ShipmentService";
import { CustomerService } from "../../../services/CustomerService";
import i18n from "@/lang/i18n";

@Component({
  components: {
    MbeFullScreenModal: FullScreenModal,
    MbeProformaModal: ProformaModal
  }
})
export default class NewShipmentToolbar extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean;
  @Prop() selectedFromCEE: boolean;
  @Prop() selectedToCEE: boolean;
  @Prop() formFilled: boolean;
  @Prop() pickupOptionVisible: boolean;
  @Prop() openProforma: boolean;
  @Prop() wineProductUS: boolean;
  @Prop() isNorthIrelandEu: boolean;
  @Prop({ default: false }) paperlessPostClosure: boolean;

  proforma = {
    invoiceNumber: 0,
    invoiceDate: "",
    declarationText: "",
    additionalComment: "",
    currency: "EUR",
    eori: "",
    totalValue: 0,
    proformaDetails: [],
    incoterms: "",
    vatNumber: "",
    fiscalCode: ""
  } as ProformaDTO;

  modalProformaVisible = false;

  get showProformaButton() {
    if (this.wineProductUS) return false;
    const hideProforma = this.$store.getters["customer/config"]
      .hideStoreProforma;
    if (hideProforma && this.shipment.proforma.createdByStore) {
      return false;
    }
    return (
      this.selectedFromCEE === false ||
      this.selectedToCEE === false ||
      this.isNorthIrelandEu
    );
  }

  modalProformaOptions = {
    classicon: "invoice-image",
    title: i18n.t("proforma"),
    closeDisabled: true
  };

  shipmentForProforma(proforma: ProformaDTO) {
    //1- Si existeix shipmentId (EDIT), caldria retornar les dades del shipment. Al llistat per exemple, ho feiem així... (TODO)
    //return this.selectedItems[0] as ShipmentManagementDef

    //2- Si NO existeix shipmentId (CREATE)...
    const newAddressFrom = {
      companyName: "",
      address: "",
      city: "",
      province: "",
      zipCode: "",
      countryId: "",
      vatNumber: "",
      phone: ""
    } as AddressShipmentDTO;
    const newAddressTo = {
      companyName: "",
      address: "",
      city: "",
      countryId: "",
      vatNumber: "",
      phone: ""
    } as AddressShipmentDTO;

    const newShipment = {
      shipmentId: "",
      shipmentDate: "",
      customerWeight: 0,
      totalNumberOfPackages: 0,
      addressFrom: newAddressFrom,
      addressTo: newAddressTo,
      proforma: proforma
    } as ShipmentManagementDef;

    return newShipment;
  }

  @Watch("openProforma")
  onOpenProformaChange(status: boolean) {
    if (!status) return;
    this.modalProformaVisible = this.openProforma;
    this.$emit("resetTriggerProformaModal");
  }

  saveProforma(p: ProformaManagementDef) {
    this.proforma = p;
    console.log(JSON.parse(JSON.stringify(this.proforma)));
    this.modalProformaVisible = false;
    this.$emit("saved-proforma");
  }

  shipmentCanBeDeleted() {
    return (
      this.shipment.status === "DRAFT_TO_BE_CLOSED" ||
      this.shipment.status === "DRAFT_NO_WAYBILL" ||
      this.shipment.status === "DRAFT_WAYBILL"
    );
  }

  deleteShipment() {
    AlertBus.$alerts
      .confirm(this.$t("confirm_delete_shipment"))
      .then((val: boolean) => {
        if (val) {
          const shipmentId = this.shipment.shipmentId;
          ShipmentService.deleteShipment(shipmentId)
            .then(res => {
              this.$snotify.success(
                this.$t("notification_shipment_deleted").toString()
              );
              this.$router.replace({ name: "ShipmentsMenuNew" });
            })
            .catch(reason => {
              const err = reason.response.data;
              if (err.code === "OPERATION_NOT_ALLOWED") {
                this.$snotify.error(
                  this.$t("notification_shipment_can_not_be_deleted").toString()
                );
              } else {
                this.$snotify.error(
                  translateErrorMessage(reason),
                  this.$t("notification_shipment_can_not_be_deleted").toString()
                );
              }
            });
        }
      });
  }

  unmounted() {
    this.$snotify.clear();
  }

  get courierCheck() {
    const canSeeCourier = this.$store.getters["customer/config"]
      .canSelectCourier;
    const canSeeCourierService = this.$store.getters["customer/config"]
      .canSelectCourierService;

    const checkCourier =
      !this.shipment.courierName && !this.shipment.courierId && canSeeCourier;
    const checkCourierService =
      !this.shipment.courierServiceName &&
      !this.shipment.courierServiceId &&
      canSeeCourierService;
    return checkCourier || checkCourierService;
  }

  get idsNoDistance() {
    return this.shipment.courierId === 14 && !this.shipment.distanceFromTo;
  }
}
